import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-compliance-final-review',
  templateUrl: './compliance-final-review.component.html',
  styleUrls: ['./compliance-final-review.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ComplianceFinalReviewComponent {}
